import {clamp, texture} from "p3";
import HealthBarHeart from "./HealthBarHeart";

export default class HealthBar extends PIXI.Container {
    constructor(characterIconTextureId="") {
        super();

        this._health = 0;
        this._hearts = [];

        this._characterIcon = null;
        this._characterIconTextureId = characterIconTextureId;

        this._panel = null;
        this._emptyContainer = null;

        this.init();
    }

    init() {
        this._panel = new PIXI.NineSlicePlane(texture("panel_lives_bg"), 40, 0, 40, 0);
        this.addChild(this._panel);

        this._setCharacterIcon();

        this._emptyContainer = new PIXI.Container();
        this.addChild(this._emptyContainer);

        this.pivot.x = this._panel.texture.width * 0.5;
    }

    update() {
        for (let i = 0, count = this._hearts.length; i < count; ++i) {
            this._hearts[i].update();
        }
    }

    _setCharacterIcon() {
        if (this._characterIconTextureId !== "") {
            this._characterIcon = new PIXI.Sprite(texture(this._characterIconTextureId));
            this._characterIcon.x = 18;
            this._characterIcon.y = -15;
            this.addChild(this._characterIcon);

            this._panel.x -= this._characterIcon.width / 2;
        }
    }

    /**
     * @param {number} count
     * @param {boolean} [animate=false]
     */
    setHearts(count, animate = false) {
        this._health = count * 4;
        this._removeHearts();

        const charIconWidth = this._characterIcon ? this._characterIcon.width : 0;
        const spacing = 42;
        const width = this._panel.width = spacing * count + 85 + charIconWidth;
        this.pivot.x = this._panel.width * 0.5;

        for (let i = 0; i < count; ++i) {
            const x = i * spacing + width * 0.5 - ((count - 1) * spacing) * 0.5;
            const empty = new PIXI.Sprite(texture("icon_life_off"));
            empty.position.set(x, 24);
            empty.anchor.set(0.5);
            this._emptyContainer.addChild(empty);

            const heart = new HealthBarHeart();
            heart.position.set(x, 24);
            this.addChild(heart);
            this._hearts[i] = heart;

            animate && heart.animateIn(i * 0.024).then();
        }
    }

    /**
     * @private
     */
    _removeHearts() {
        for (let i = 0, count = this._hearts.length; i < count; ++i) {
            this._hearts[i].destroy();
        }
        this._hearts.length = 0;

        this._emptyContainer.removeChildren();
    }

    /**
     * @return {number}
     */
    get health() {
        return this._health;
    }

    /**
     * @param {number} value
     */
    set health(value) {
        const lastHealth = this._health;
        this._health = clamp(value, 0, this.healthMax);
        const animate = this._health !== lastHealth;

        for (let i = 0, count = this._hearts.length; i < count; ++i) {
            const heart = this._hearts[i];
            heart.health = value - i * 4;
            heart.warning = value <= this.healthMax * 0.5;
            animate && heart.animateIn();
        }
    }

    /**
     * @return {number}
     */
    get healthMax() {
        return 4 * this._hearts.length;
    }
}